import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { withFatalCheck } from '../error/withFatalCheck'
import { ProductMetaInfo, Key } from './productMetaInfo'
import * as st from './productMetaInfo.module.scss'

const pvMovieAtfKeys = [
  Key.Directors,
  Key.Starring,
  Key.Genres,
  Key.Subtitles,
  Key.AudioTracks
]

const pvTVAtfKeys = [
  Key.Starring,
  Key.Genres,
  Key.Subtitles,
  Key.AudioTracks
]

const retailMovieAtfKeys = [
  Key.Genres,
  Key.Directors,
  Key.Starring
]

const retailTVAtfKeys = [
  Key.Genres,
  Key.Starring
]

const getFields = (isRetail: boolean, isTV: boolean) => {
  if (isRetail && isTV) {
     return retailTVAtfKeys
  } else if (isRetail && !isTV) {
    return retailMovieAtfKeys
  } else if (!isRetail && isTV) {
    return pvTVAtfKeys
  } else {
    return pvMovieAtfKeys
  }
}

export interface IATFProductMetaInfoProps
  extends WpsRuntime.atv.wps.DetailFragmentModelProps {
  isRetail: boolean
  isTV: boolean
}
const AtfProductMetaInfoValid: React.ComponentType<IATFProductMetaInfoProps> = (
  props: IATFProductMetaInfoProps
) => (
  <div className={`${st.atfInfo} dv-dp-node-meta-info avu-full-width`} >
    <ProductMetaInfo {...props} fields={getFields(props.isRetail, props.isTV)} expandedItemsCount={40} id={"meta-info"}/>
  </div>
)

export const AtfProductMetaInfo = withFatalCheck(AtfProductMetaInfoValid)
